import { MapCluster } from '../models/map.cluster';
import { MapMarker } from '../models/map.marker';

declare var MarkerClusterer: any;

export class GMapCluster extends MapCluster {
    private cluster: any;

    constructor(id: number, maxZoom0: number, mapComponent: any, map: any) {
        super(id, mapComponent, map, maxZoom0);
        this.cluster = new MarkerClusterer(this.map, undefined, {
            imagePath: 'assets/images/cluster/m',
            maxZoom: maxZoom0,
            ignoreHidden: true
        });
    }

    addMarker(marker: MapMarker) {
        marker.marker.setMap(null); // Esto es para que no se muestre el marcador antes de meterse en el cluster
        this.cluster.addMarker(marker.marker, false);
    }

    removeMarker(marker: MapMarker) {
        this.cluster.removeMarker(marker);
    }

    removeMarkers() {
        this.cluster.clearMarkers();
    }

    repaint() {
        this.cluster.repaint();
    }

}
